export const menuList = [
  {
    title: "Menu",
    id: "Dyt8xnbzif",
    menus: [
      {
        title: "Dashboard",
        icon: "ri-dashboard-fill",
        route: "dashboard",
        access: ["v40", "v77"],
      },
      // {
      //   title: "Account Dashboard",
      //   icon: "ri-dashboard-3-fill",
      //   route: "account-dashboard",
      //   access: ["y93422"],
      // },
      // {
      //   icon: " ri-team-line",
      //   route: "menu",
      //   // id: "ZMi3qdP",
      //   access: ["y73886", "y11795"],
      //   subchildren: [
      //
      //   ],
      // },
      {
        title: "Category Management",
        icon: " ri-user-line",
        route: "menu",
        id: "j95op9e569VxUkZ427Ee",
        access: ["y73886", "y11795"],
        subchildren: [
          {
            title: "Categories",
            icon: "ri-team-line",
            route: "categories",
            access: ["y73886"],
          },
          {
            title: "New category",
            icon: "ri-team-line",
            route: "categories",
            params: { params: "034a948e37322172ae8a0821" },
            access: ["y11795"],
          },
        ],
      },
      {
        title: "Products",
        icon: " ri-stack-fill",
        route: "menu",
        id: "03a61fe9b54605efc10f5540",
        access: ["y48700", "y99595"],
        subchildren: [
          {
            title: "Products",
            icon: "ri-file-list-line",
            route: "product-list",
            access: ["y48700"],
          },
          {
            title: "New Product",
            icon: "ri-add-fill",
            route: "add-product",
            access: ["y99595"],
          },
        ],
      },
      {
        title: "Order",
        icon: " ri-stack-fill",
        route: "menu",
        id: "03a61fe9b54605efcqei0209",
        access: ["y10227", "y99595"],
        subchildren: [
          {
            title: "Orders",
            icon: "ri-file-list-line",
            route: "order-list",
            access: ["y10227"],
          },
          // {
          //   title: "New Stock",
          //   icon: "ri-add-fill",
          //   route: "add-stocks",
          //   access: ["y99595"],
          // },
        ],
      },
      // {
      //   title: "Order Management",
      //   icon: "ri-list-unordered",
      //   route: "orders",
      //   // access: ["v40", "v77"],
      // },
      // {
      //   title: "Delivery Location",
      //   icon: "ri-map-pin-line",
      //   route: "delivery",
      //   // access: ["v40", "v77"],
      // },
    ],
  },

  // {
  //   title: "Config Menu",
  //   id: "RaglsIozLG",
  //   menus: [
  //     {
  //       title: "Settings",
  //       icon: "ri-settings-2-fill",
  //       route: "menu",
  //       id: "HX2jEkeTU0",
  //       access: ["y99468", "y37228", "y53416"],
  //       subchildren: [
  //         {
  //           title: "App info",
  //           route: "appInfo",
  //           icon: "ri-wallet-line",
  //           access: ["y53416"],
  //         },
  //         {
  //           title: "All roles",
  //           route: "role-mng",
  //           icon: "ri-wallet-line",
  //           access: ["y37228"],
  //         },
  //         {
  //           title: "New role",
  //           route: "newRole",
  //           icon: "ri-add-circle-line",
  //           access: ["y99468"],
  //         },
  //       ],
  //     },
  //   ],
  // },
];
